import DataTypeIcon from './DataTypeIcon';
import IntegrationIcon from './IntegrationIcon/IntegrationIcon';

export default {
	DataTypeIcon,
	IntegrationIcon,
};
